import { decryptJson } from '@/helpers/crypto/crypto'
function isMenuAccessible(categoryMenu, url, isExist = []) {
  function extractMenus(categoryMenu) {
    const result = [];
    function traverseMenus(menus) {
      menus.forEach((menu) => {
        if (menu.subMenus && menu.subMenus.length > 0) {
          traverseMenus(menu.subMenus);
        } else {
          result.push(menu);
        }
      });
    }
    categoryMenu.forEach((category) => {
      traverseMenus(category.menus);
    });
    return result;
  }

  const menu = extractMenus(categoryMenu);
  for (let i = 0; i < menu.length; i++) {
    if (isExist.length > 0) break;
    if (menu[i].path === url) {
      isExist.push(menu[i].path);
      break;
    }
  }
  return isExist;
}

export default function ({ next, to }) {
  var toPath = to.path;
  if (to.matched.some((record) => record.meta.parentPath)) {
    toPath = to.meta.parentPath;
  }
  if (isMenuAccessible(decryptJson(localStorage.getItem("dataUser")).categoryMenu, toPath).length === 0) {
    return next({ name: "PageNotFound" });
  }
  next();
}